import { FC, useEffect, useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useUser } from '../../common/hooks/auth/useUser'
import InfoMessage from '../../components/common/info-message'
import MainNav from '../../components/homepage/main-nav'
import Layout from '../../components/layout/layout'
import { useTranslation } from '../../useTranslation'
import { isValidGUID } from '@ringo/shared'
import { useLocalStorage } from '../../common/hooks/useLocalStorage'

export const Impersonate: FC = () => {
    const { t } = useTranslation()
    const { setItem } = useLocalStorage()
    const { refreshUserData, removeUser } = useUser()
    const navigate = useNavigate()

    const [params] = useSearchParams()
    const userId = params.get('userId')
    const token = params.get('token')

    const isValid = useMemo(() => {
        return userId && token && (location.protocol === 'https:' || import.meta.env.VITE_ENV_NAME === 'LOCAL') && isValidGUID(userId)
    }, [userId, token])

    useEffect(() => {
        if (!isValid) {
            return
        }

        setItem('token', token!)
        refreshUserData()
            .then(() => navigate('/auth/login'))
            .catch((_error) => removeUser())
    }, [])

    if (!isValid)
        return (
            <Layout>
                <MainNav />
                <div className="px-56">
                    <InfoMessage type={'error'} label={t('internalServerError')}></InfoMessage>
                </div>
            </Layout>
        )

    return null
}
